import {parseAndExtractTextFromLexicalJson} from 'components/DSYS/editor/utils/lexical';

export type StarrableOutcomeType = 'milestone' | 'deliverable';

export const getPlainTextTitle = (title: string) => {
  try {
    return parseAndExtractTextFromLexicalJson(title) || title;
  } catch {
    return title;
  }
};

export const isStarrableOutcome = <T extends {type?: string | null}>(
  item: T
): item is T & {type: StarrableOutcomeType} =>
  item.type === 'milestone' || item.type === 'deliverable';

// Display-time normalization for saved outcome links: keep an existing http(s)
// scheme in any letter case, otherwise assume https.
export const normalizeExternalUrl = (url: string) =>
  /^https?:\/\//i.test(url) ? url : `https://${url}`;
